define([
	"dojo/_base/declare",
	"csi/datasheet/Widget",
	"csi/resolver"
], function(declare,DataSheetWidget,resolver) {

	return declare(DataSheetWidget, {
		_resolveView: function() {
			// summary: assign custom view key
			var	node = this.getViewNode();
			if (node) {
				var parentNode = resolver.resolveParent(node);
				if (parentNode) {
					this.prefKey = this.defView.getKey(parentNode.$Type);
				}
			}

			this.inherited(arguments);
		}
	});
});